var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":() => _vm.show_dialogs.send_cbr=true}},[_vm._v("Multi-account CBR")]),_vm._v(" "),_c('multi-account-cbr-dialog',{attrs:{"show":_vm.show_dialogs.send_cbr,"selected_employers":_vm.selected_employers},on:{"close":function($event){_vm.show_dialogs.send_cbr = false}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }